import React from "react";
import Home from "@material-ui/icons/Home";
import AdminDrawerContent from "./AdminDrawerContent";
import { useApp } from "../../hooks/useApp";
import { AdapterLink } from "../../../../components/Adopter";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { createStyles, Theme } from "@material-ui/core";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    list: {
      width: 300,
    },
  }),
);

const DashboardDrawer = (props) => {
  const classes = useStyles();
  const {
    data: { isAdminDrawerOpen },
    actions: { toggleAdminDrawer },
  } = useApp();

  return (
    <Drawer
      variant="temporary"
      open={isAdminDrawerOpen}
      onClose={toggleAdminDrawer}
    >
      <List className={classes.list}>
        <ListItem
          onClick={toggleAdminDrawer}
          button
          component={AdapterLink}
          to={"/0"}
        >
          <ListItemIcon>
            <Home />
          </ListItemIcon>
          <ListItemText primary={"Dashboard"} />
        </ListItem>
      </List>

      <Divider />

      <AdminDrawerContent />
    </Drawer>
  );
};

export default React.memo(DashboardDrawer);
